import { INearService } from "./INearService";
import { Near, connect as nearConnect } from "near-api-js";
import { convertYoctoToNear } from "./utils/near.utils";
import Connected from "./decorators/NearService.decorator";

export default class NearService implements INearService {
    private connection: Near | undefined;

    constructor(private readonly nearNetwork: string) {}

    @Connected()
    async getBalance(address: string): Promise<string> {
        const account = await this.connection!.account(address); // skipcq: JS-0339
        const { available } = await account.getAccountBalance();
        return convertYoctoToNear(available);
    }

    async connect(): Promise<void> {
        if (this.connection) return;

        const connectionConfig = {
            networkId: this.nearNetwork,
            nodeUrl: `https://rpc.${this.nearNetwork}.fastnear.com`,
        };

        this.connection = await nearConnect(connectionConfig);
    }
}
